import { alpha, styled } from '@mui/material';
import { Stack } from '@mui/system';

export const StyledChannelContainer = styled(Stack, {
  shouldForwardProp: (prop) =>
    prop !== 'hasConnection' && prop !== 'connected' && prop !== 'active',
})<{ hasConnection: boolean; connected: boolean; active: boolean }>(
  ({ hasConnection, connected, active, theme }) => ({
    borderRadius: theme.spacing(1),
    backgroundColor: connected
      ? alpha(theme.palette.success.main, 0.12)
      : 'transparent',
    border: `1px solid transparent`,
    '& .MuiMenuItem-root.connected': {
      paddingLeft: theme.spacing(1),
    },
    // ...(hasConnection &&
    //   !connected && {
    //     backgroundColor: alpha(theme.palette.action.disabledBackground, 0.08),
    //   }),
    ...(connected &&
      active && {
        borderColor: theme.palette.success.main,
      }),
  }),
);
